import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';

export class AccDocumentDetailsResultDto {
    allowAddProjectDocument: boolean;
    allowUnlinkProjectDocument: boolean;
    allowAddItemDocument: boolean;
    allowUnlinkItemDocument: boolean;

    @Type(() => FileInfoDisplayResultDto)
    projectDocuments: FileInfoDisplayResultDto[];

    @Type(() => FileInfoDisplayResultDto)
    itemDocuments: FileInfoDisplayResultDto[];
}
